/* eslint-disable */
import { useDispatch, useSelector } from 'react-redux'
import { createOrder, updateOrder } from '../ActionCreators'
import { apiCreateOrder, apiMakePosOrdersTotal } from '../Api'
import { getSelectedPromotions } from '../../selectors/promotion'
import { formatItems } from '../../hooks/useRemoteOrderTotal'
import { getCurrentMenu, getIsKiosk } from '../../selectors/menus'
import { getCartItems } from '../../selectors/cart'
import { useEffect, useState } from 'react'
import { VNORDERS_STATES } from '../Enums'
import { getCurrentOrder, getCurrentOrderUuid, getTempCurrentOrderPayments } from '../Selectors'
import { setRoute } from '../../VNRoutes/ActionCreators'
import { isEmpty } from '../../VNUtil/VNUtils'
import { getActiveAttendantId } from '../../selectors/attendant'
import { makeCreateOrderLineItems } from '../../utils/orderUtils'
import uuidv4 from 'uuid/v4'

export const useVNOrders = () => {
  const dispatch = useDispatch()

  const promotions = useSelector(getSelectedPromotions)
  const isKiosk = useSelector(getIsKiosk)
  const orderMenuItems = useSelector(getCartItems)
  const menu = useSelector(getCurrentMenu)
  const activeAttendantId = useSelector(getActiveAttendantId)

  const currentOrderUuid = useSelector(getCurrentOrderUuid)
  const currentOrder = useSelector(getCurrentOrder)

  const tempCurrentOrderPayments = useSelector(getTempCurrentOrderPayments)

  const [isTotaling, setIsTotaling] = useState(false)
  const [nextRoutingLocation, setNextRoutingLocation] = useState(null)
  const [localCurrentOrderUuid, setLocalCurrentOrderUuid] = useState(null)

  const calculatePaymentsOnOrders = async () => {
    console.log('calculatePaymentsOnOrders')

    let amountLeftToPay = currentOrder.get('total_amount_in_cents')
    const payments = []

    tempCurrentOrderPayments.map((payment, paymentUuid) => {
      console.log('paymentUuid', paymentUuid)
      console.log(payment.toJS())
      payments.push(payment)
      amountLeftToPay -= payment.get('amount_in_cents')
    })

    console.log('amountLeftToPay', amountLeftToPay)
    if (amountLeftToPay <= 0) {
      console.log('Payments all equal the order total; sync it!')
      await createOrderOnServer(payments, currentOrderUuid)
    }
  }

  // payment was added to an order
  useEffect(() => {
    console.log('tempCurrentOrderPayments', tempCurrentOrderPayments)

    if (tempCurrentOrderPayments && !tempCurrentOrderPayments.isEmpty()) {
      calculatePaymentsOnOrders()
    }
  }, [tempCurrentOrderPayments])

  useEffect(() => {
    console.log(`currentOrderUuid`, currentOrderUuid)
    console.log(`localCurrentOrderUuid`, localCurrentOrderUuid)
    if (currentOrderUuid !== localCurrentOrderUuid) {
      console.log('useEffect currentOrderUuid')
      setLocalCurrentOrderUuid(currentOrderUuid)
      totalOrder(currentOrderUuid)
    }
  }, [currentOrderUuid])

  useEffect(() => {
    if (currentOrder?.get('orderState') === VNORDERS_STATES.TOTALED) {
      console.log('Totaling is Complete')
      setIsTotaling(false)
      if (nextRoutingLocation) {
        console.log('navigate to next route')
        setNextRoutingLocation(null)
        dispatch(setRoute(nextRoutingLocation))
      }
    }
  }, [currentOrder])

  const createOrderOnServer = async (payments, orderUuid) => {
    let stadiumResponse

    console.log('orderMenuItems')
    console.log(orderMenuItems)

    const tempOrderItems = []
    orderMenuItems.forEach((menuItem) => {
      tempOrderItems.push({
        uuid: uuidv4(),
        menu_item_uuid: menuItem.uuid,
        quantity: menuItem.quantity,
        price: menuItem.defaultPriceInCents / 100,
        modifiers: [[]],
        notes: null,
      })
    })

    try {
      stadiumResponse = await apiCreateOrder(payments, activeAttendantId, tempOrderItems, menu?.uuid, isKiosk, orderUuid)
    } catch (e) {
      console.log(e)
    }

    console.log(stadiumResponse)
  }

  const startOrder = async (actionParams) => {
    if (!isEmpty(actionParams) && actionParams.route) {
      setNextRoutingLocation(actionParams.route)
    }

    dispatch(createOrder())
  }

  const totalOrder = async (orderUuid) => {
    if (!isTotaling) {
      setIsTotaling(true)
      console.log('totalOrder')

      let stadiumResponse

      try {
        stadiumResponse = await apiMakePosOrdersTotal(promotions, formatItems(orderMenuItems), menu?.uuid, isKiosk, orderUuid)
      } catch (e) {
        console.log(e)
      }

      console.log(stadiumResponse)

      const updatedOrder = {
        ...stadiumResponse.data,
        orderState: VNORDERS_STATES.TOTALED,
      }

      dispatch(updateOrder(updatedOrder))
    }
  }

  return {
    totalOrder,
    startOrder,
  }
}
